<template>
  <v-form
    ref="personForm"
    v-model="personFormValid"
  >
    <v-text-field
      v-model="newPerson.name"
      autocomplete="off"
      class="mb-1"
      outlined
      label="Nimi"
      :disabled="selectedPersonId !== ''"
      :rules="[rules.required]"
      required
    />
    <v-text-field
      v-model="newPerson.email"
      autocomplete="off"
      class="mb-1"
      outlined
      label="Sähköposti"
      :rules="[rules.required, rules.email]"
      required
    />
    <v-text-field
      v-model="newPerson.ssn"
      class="mb-1"
      autocomplete="off"
      outlined
      label="Henkilötunnus"
      :rules="[rules.required, rules.ssn]"
      required
    />
    <v-select
      v-model="newPerson.role"
      :items="roles"
      item-text="name"
      item-value="value"
      label="Rooli"
      outlined
    />
  </v-form>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'FileSignerForm',

  props: {
    newPerson: {
      type: Object,
      default: () => {},
    },
    selectedPersonId: {
      type: String,
      default: () => '',
    },
    people: {
      type: Array,
      default: () => ({}),
    },
  },
  data: () => ({
    roles: [
      {
        name: 'Allekirjoittaja',
        value: 'signer',
      },
      {
        name: 'Katselija',
        value: 'observer',
      },
    ],
    personFormValid: false,
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
      ssn: (value) => {
        const pattern = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d-|[01]\dA)\d{3}[\dABCDEFHJKLMNPRSTUVWXY]$/;
        return pattern.test(value) || 'Virheellinen henkilötunnus.';
      },
    },
  }),
  methods: {
    closeOffererDialog() {
      this.$bus.$emit('closeFileSignerDialog');
    },
    resetForm() {
      this.newPerson.name = '';
      this.newPerson.email = '';
      this.newPerson.ssn = '';
      this.newPerson.role = 'signer';
    },
    addFileSigner() {
      this.$refs.personForm.validate();
      if (this.personFormValid) {
        this.people.push(_.cloneDeep(this.newPerson));
        this.resetForm();
        this.$refs.personForm.resetValidation();
        this.newPerson.isCompany = false;
        this.$bus.$emit('closeFileSignerDialog');
      }
    },
  },
};
</script>
